module.exports = __webpack_public_path__ + "static/img/charge3.9ebd260e.png";